import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_DETAILS, ACTION_LIST } from "models/role/action";
import {
  SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION,
  SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
  SUBJECT_CREDIT_NOTIFICATION_PREFERENCES,
  SUBJECT_PAYOUTS_NOTIFICATIONS,
} from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const List = lazyRetryWithPreload(() => import("../pages/List"), "List");

const Details = lazyRetryWithPreload(
  () => import("../pages/Details"),
  "Details"
);

const Configuration = lazyRetryWithPreload(
  () => import("../pages/Configuration"),
  "Configuration"
);

const Payments = lazyRetryWithPreload(
  () => import("../pages/Payments"),
  "Payments"
);

const Accounts = lazyRetryWithPreload(
  () => import("../pages/Accounts"),
  "Accounts"
);

export const voltAccountsRoutes: Route[] = [
  {
    title: [COMMON_TRANSLATION_KEYS.accountsSidebarTitle],
    path: PAGE_URLS.list,
    showChildrenInSidebar: false,
    component: List,
    can: {
      do: ACTION_LIST,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
  {
    path: PAGE_URLS.details,
    component: Details,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
    hasNestedSwitch: true,
  },
  {
    path: PAGE_URLS.configuration,
    component: Configuration,
    showChildrenInSidebar: false,
    can: {
      or: [
        {
          do: ACTION_LIST,
          on: SUBJECT_CREDIT_NOTIFICATION_PREFERENCES,
        },
        {
          do: ACTION_LIST,
          on: SUBJECT_PAYOUTS_NOTIFICATIONS,
        },
        {
          do: ACTION_LIST,
          on: SUBJECT_CASH_MANAGEMENT_SETTLEMENT_NOTIFICATION,
        },
      ],
    },
  },
  {
    path: PAGE_URLS.payments,
    component: Payments,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
  {
    path: PAGE_URLS.accounts,
    component: Accounts,
    showChildrenInSidebar: false,
    hasNestedSwitch: true,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
];
